import {
  Anchor,
  ArrowLeft,
  Award,
  BarChart3,
  BookOpen,
  Boxes,
  BrainCircuit,
  Check,
  ChevronRight,
  CircleHelp,
  ClipboardList,
  Compass,
  Crosshair,
  Download,
  Edit3,
  Footprints,
  Gamepad2,
  Grid3X3,
  Home,
  LayoutDashboard,
  LockKeyhole,
  LogOut,
  Mail,
  Map,
  MapPinned,
  Menu,
  Navigation,
  Orbit,
  PanelLeftClose,
  Play,
  Plus,
  Rocket,
  Save,
  ScrollText,
  Settings2,
  Shapes,
  ShieldAlert,
  Sparkles,
  Swords,
  Trophy,
  Upload,
  User,
  UserPlus,
  Users,
  WandSparkles,
  X,
  Zap,
  type LucideProps,
} from "lucide-react";

const icons = {
  Anchor,
  ArrowLeft,
  Award,
  BarChart3,
  BookOpen,
  Boxes,
  BrainCircuit,
  Check,
  ChevronRight,
  CircleHelp,
  ClipboardList,
  Compass,
  Crosshair,
  Download,
  Edit3,
  Footprints,
  Gamepad2,
  Grid3X3,
  Home,
  LayoutDashboard,
  LockKeyhole,
  LogOut,
  Mail,
  Map,
  MapPinned,
  Menu,
  Navigation,
  Orbit,
  PanelLeftClose,
  Play,
  Plus,
  Rocket,
  Save,
  ScrollText,
  Settings2,
  Shapes,
  ShieldAlert,
  Sparkles,
  Swords,
  Trophy,
  Upload,
  User,
  UserPlus,
  Users,
  WandSparkles,
  X,
  Zap,
};

export type IconName = keyof typeof icons;

export function Icon({
  name,
  ...props
}: LucideProps & { name: string }) {
  const Component = icons[name as IconName] ?? CircleHelp;
  return <Component aria-hidden="true" {...props} />;
}
